module.exports = __webpack_public_path__ + "static/media/oneThirdCenter.d729c525.png";